import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, Navbar } from "../components";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import { formatDate, calculateDifference, dateMonthYears, renderStars } from "./Utils";
import "../assets/stylesheet/bootstrap.min.css";
import "../assets/stylesheet/all-fontawesome.min.css";
import "../assets/stylesheet/animate.min.css";
import "../assets/stylesheet/magnific-popup.min.css";
import "../assets/stylesheet/owl.carousel.min.css";
import "../assets/stylesheet/style.css";

import courseImage from '../../src/assets/img/course/01.jpg'
import courseImage1 from '../../src/assets/img/course/02.jpg'

import { debounce } from 'lodash'; // Optional for debouncing

function CourseDetail(props) {

    const { id } = useParams();
    console.log(id);
    const [ids, setIds] = useState(id);
    console.log(ids);
    const navigate = useNavigate();
    const [createdBy, setCreatedBy] = useState([]);
    const [courseDetailBasedOnUserid, setCourseDetailBasedOnUserid] = useState([]);
    const [rating, setRating] = useState(0);
    const [courseDetails, setCourseDetails] = useState(null);
    const [averageRatings, setAverageRatings] = useState([]);
    const [courseRatingCount, setCourseRatingCount] = useState([]);
    const [course, setCourse] = useState(""); // State to hold roles data
    // Search Start
    const [query, setQuery] = useState('');
    const [searchTeachers, setSearchTeachers] = useState([]);
    const [searchCourses, setSearchCourses] = useState([]);
    const [searchInstitutes, setSearchInstitutes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    
    // Handle search input change
    const handleChange = (e) => {
        setQuery(e.target.value);
    };

    // Debounced search function to limit API calls
    // const handleSearch = debounce(async () => {
    //     if (!query.trim()) return;
    //     setLoading(true);
    //     setError('');
    //     try {
    //         const response = await axios.get(API_BASE_URL + `/courseSearch?query=${query}`);
    //         console.log(response.data.data);
    //         // setTeachers(response.data.teachers);
    //         setSearchCourses(response.data.data);
    //         // setInstitutes(response.data.institutes);
    //     } catch (err) {
    //         setError('An error occurred while searching.');
    //     } finally {
    //         setLoading(false);
    //     }
    // }, 500); // Debounce delay of 500ms

    const handleSearch = debounce(async () => {
        if (!query.trim()) return;
    
        setLoading(true);
        setError('');
        try {
            const response = await axios.get(
                `${API_BASE_URL}/courseSearch?query=${query}`,
                {
                    headers: {
                        "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`, // Replace with your actual token
                        "Content-Type": "application/json",
                    },
                }
            );
            console.log(response.data.data);
            setSearchCourses(response.data.data);
        } catch (err) {
            setError('An error occurred while searching.');
        } finally {
            setLoading(false);
        }
    }, 500);

    // Trigger search on key press (after debouncing)
    useEffect(() => {
        handleSearch();
    }, [query]); // Trigger handleSearch when the query changes
    // Handle course click to navigate to the detail page
    const handleCourseClick = (courseId) => {
        setCourseDetails(courseId);
        navigate(`/CourseDetail/${courseId}`); // Navigate to the course detail page
    };
    // Effect to fetch the course details when courseId changes
    useEffect(() => {
        fetchCoursesDetails(id); // Fetch new details every time the courseId changes
    }, [id]);  // Dependency array ensures the effect runs when courseId changes
    // Search End
    const handleAddToCart = async () => {
        const cartItem = {
            courses_details_id: course.id,
            price: course.course_price,
            quantity: 1, // This can be dynamic based on user input
            user_id: ACCESS_Log_In_User_Id(),
        };

        try {
            await addToCart(cartItem);
            navigate('/coursecart');
            //alert('Product added to cart!');

        } catch (error) {
            console.error('Error adding to cart:', error);
            alert('Failed to add product to cart');
        }
    };
    const addToCart = async (cartItem) => {
        const response = await axios.post(`${API_BASE_URL}/cart/add`, cartItem, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`, // Adjust for your auth strategy
            },
        });
        return response.data;
    };

    // const fetchCoursesDetails = async (ids) => {
    //     try {
    //         setLoading(true);
    //         const url = API_BASE_URL + '/getCoursesDetailsById/' + ids
    //         const response = await axios.get(url);
    //         setCourse(response.data[0]); // Set roles data to state
    //     } catch (err) {
    //         // setError(err.message); // Handle error

    //     }
    //     setLoading(false);
    // };
    // const fetchCourseDetailBasedOnUserid = async () => {
    //     const payload = {
    //         "user_id": course.user_id,
    //     }
    //     try {
    //         axios.post(API_BASE_URL + '/getCoursesDetailsByUserId', payload)
    //             .then(function (response) {
    //                 if (response.data.code == 200) {
    //                     setCourseDetailBasedOnUserid(response.data.data);
    //                 }
    //             })
    //             .catch(function (error) {
    //                 console.log(error);
    //             });

    //     } catch (err) {
    //         // Handle errors
    //         setError(err.message);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    // const fetchCreatedBy = async () => {
    //     try {
    //         axios.get(`${API_BASE_URL}/getCoursesCreatedBy?user_id=${course.user_id}`)
    //             .then(function (response) {

    //                 if (response.data.code == 200) {
    //                     setCreatedBy(response.data.data);
    //                 }
    //             })
    //             .catch(function (error) {
    //                 console.log(error);
    //             });

    //     } catch (err) {
    //         // Handle errors
    //         setError(err.message);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const fetchCoursesDetails = async (ids) => {
        try {
            setLoading(true);
            const url = API_BASE_URL + '/getCoursesDetailsById/' + ids;
            const response = await axios.get(url, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`, // Replace with your actual token
                    "Content-Type": "application/json",
                },
            });
            console.log(response.data[0]);
            setCourse(response.data[0]); // Set roles data to state
        } catch (err) {
            console.error(err); // Handle error
        } finally {
            setLoading(false);
        }
    };
    
    const fetchCourseDetailBasedOnUserid = async () => {
        const payload = {
            "user_id": ACCESS_Log_In_User_Id(),
        };
    
        try {
            await axios.post(API_BASE_URL + '/getCoursesDetailsByUserId', payload, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`, // Replace with your actual token
                    "Content-Type": "application/json",
                },
            })
            .then(function (response) {
                if (response.data.code === 200) {
                    setCourseDetailBasedOnUserid(response.data.data);
                }
            })
            .catch(function (error) {
                console.error(error);
            });
        } catch (err) {
            console.error(err); // Handle errors
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    
    const fetchCreatedBy = async () => {
        try {
            await axios.get(`${API_BASE_URL}/getCoursesCreatedBy?user_id=${ACCESS_Log_In_User_Id()}`, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`, // Replace with your actual token
                    "Content-Type": "application/json",
                },
            })
            .then(function (response) {
                if (response.data.code === 200) {
                    setCreatedBy(response.data.data);
                }
            })
            .catch(function (error) {
                console.error(error);
            });
        } catch (err) {
            console.error(err); // Handle errors
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        fetchCreatedBy();
        fetchCourseDetailBasedOnUserid();
        fetchCoursesDetails(ids); // Call the fetch function
    }, []); // Empty dependency array to run only on mount

    // Rating start
    // const fetchRatings = async () => {
    //     setLoading(true);
    //     try {
    //         const url = API_BASE_URL + '/ratings/course/' + ids
    //         const response = await axios.get(url);
    //         const courserating = response.data.data;
    //         const averageRatingsss = calculateAverageRating(courserating);
    //         setAverageRatings(averageRatingsss);
    //         renderStars(averageRatingsss)
    //     } catch (err) {
    //         setError(err.message);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const fetchRatings = async () => {
        setLoading(true);
        try {
            const url = API_BASE_URL + '/ratings/course/' + ids;
            const response = await axios.get(url, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`, // Replace with your actual token
                    "Content-Type": "application/json",
                },
            });
    
            const courserating = response.data.data;
            console.log("courserating",courserating);
            const count = courserating.length;
            setCourseRatingCount(count);
            const averageRatingsss = calculateAverageRating(courserating);
            setAverageRatings(averageRatingsss);
            renderStars(averageRatingsss); // Call function to render stars
        } catch (err) {
            console.error(err); // Log error for debugging
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        fetchRatings();
    }, [course]);

    // const handleRating = async (star, courseDetail_id) => {
    //     setRating(star);
    //     setcourseDetailId(courseDetail_id);
    //     await axios.post(API_BASE_URL + '/ratings', {
    //         user_id: ACCESS_Log_In_User_Id(), // Replace with actual user id
    //         courseDetail_id: courseDetail_id,
    //         rating: star,
    //     });
    //     fetchRatings(); // Refresh ratings
    // };

    const handleRating = async (star, courseDetail_id) => {
        setRating(star);
        //setcourseDetailId(courseDetail_id);
    
        try {
            await axios.post(
                `${API_BASE_URL}/ratings`,
                {
                    user_id: ACCESS_Log_In_User_Id(), // Replace with actual user ID retrieval logic
                    courseDetail_id: courseDetail_id,
                    rating: star,
                },
                {
                    headers: {
                        "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`, // Replace with your actual token
                        "Content-Type": "application/json",
                    },
                }
            );
    
            fetchRatings(); // Refresh ratings
        } catch (error) {
            console.error("Error submitting rating:", error); // Log error for debugging
        }
    };
    
    const calculateAverageRating = (ratingsArray) => {
        const totalRating = ratingsArray.reduce((sum, ratingObj) => sum + ratingObj.rating, 0);
        return (totalRating / ratingsArray.length).toFixed(2); // Return average rounded to 2 decimal places

    };

    // Rating end
    console.log("course course",course)
    return (
        <div>
            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
                </svg>
            </div>
            {/* ==================== Scroll to Top End Here ==================== */}

            {/* ==================== Mobile Menu Start Here ==================== */}
            <div className="mobile-menu d-lg-none d-block">
                <button type="button" className="close-button"> <i className="las la-times"></i> </button>
                <div className="mobile-menu__inner">
                    <div className="mobile-menu__menu">
                        <ul className="nav-menu flx-align nav-menu--mobile">
                            <li className="nav-menu__item activePage">
                                <a href="" className="nav-menu__link">Home</a>
                            </li>
                            <li className="nav-menu__item">
                                <a href="course.html" className="nav-menu__link">Courses</a>
                            </li>
                            <li className="nav-menu__item">
                                <a href="" className="nav-menu__link">Feed</a>
                            </li>
                            <li className="nav-menu__item">
                                <a href="" className="nav-menu__link">Videos</a>
                            </li>
                            <li className="nav-menu__item">
                                <a href="" className="nav-menu__link">Teachers</a>
                            </li>
                            <li className="nav-menu__item">
                                <a href="" className="nav-menu__link">Institutes</a>
                            </li>
                            <li className="nav-menu__item has-submenu">
                                <a href="javascript:void(0)" className="nav-menu__link">My Profile</a>
                                <ul className="nav-submenu">
                                    <li className="nav-submenu__item">
                                        <a href="" className="nav-submenu__link"> Edit Profile</a>
                                    </li>
                                    <li className="nav-submenu__item">
                                        <a href="" className="nav-submenu__link"> Enrolled Courses</a>
                                    </li>
                                    <li className="nav-submenu__item">
                                        <a href="" className="nav-submenu__link"> Your Posts</a>
                                    </li>
                                    <li className="nav-submenu__item">
                                        <a href="" className="nav-submenu__link"> Certificates</a>
                                    </li>
                                    <li className="nav-submenu__item">
                                        <a href="" className="nav-submenu__link"> Chats</a>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-menu__item">
                                <a href="" className="nav-menu__link">Scan OR Code</a>
                            </li>
                        </ul>
                        <div className="header-right__inner d-lg-none my-3 gap-1 d-flex flx-align">
                            <a href="" className="btn btn-main pill sign_btn px-sm-4">
                                Signup/Login
                            </a>
                        </div>
                    </div>
                </div>
            </div>


            <main class="bg_all">
                <Navbar/>
        <div class="site-breadcrumb" style={{
    backgroundImage: `url('/assets/img/breadcrumb/01.jpg')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "200px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff", // Ensure text is readable
  }}>
            <div class="container">
                <h2 class="breadcrumb-title">Course Details</h2>
                <ul class="breadcrumb-menu">
                    <li><a href="index-2.html">Home</a></li>
                    <li class="active">Course Details</li>
                </ul>
            </div>
        </div>
      
       <div class="course-single-area py-5">
            <div class="container">
                <div class="course-single-wrapper">
                    <div class="row">
                        <div class="col-xl-8 col-lg-8">
                            <div class="course-details course_wraper">
                                
                                <div class="course-details">
                                    <h3 class="mb-20"> {course.course_title}</h3>
                                    <p class="mb-20"  dangerouslySetInnerHTML={{ __html: course.course_description }}>
                                   
                                    </p>
                                    {/* <p class="mb-20">
                                        But I must explain to you how all this mistaken idea of denouncing pleasure and
                                        praising pain was born and I will give you a complete account of the system, and
                                        expound the actual teachings of the great explorer of the truth, the
                                        master-builder of human happiness. No one rejects, dislikes, or avoids pleasure
                                        itself, because it is pleasure, but because those who do not know how to pursue
                                        pleasure rationally encounter consequences that are extremely painful. Nor again
                                        is there anyone who loves or pursues or desires to obtain pain of itself,
                                        because it is pain, but because occasionally circumstances occur in which toil
                                        and pain can procure him some great pleasure. To take a trivial example
                                    </p> */}
                                    <div class="row">
                                        <div class="col-md-6 mb-20">
                                            {/* <img src={`${Image_Base_Url}${course.course_image_path}`} alt=""/> */}
                                               <img
                                                                      src={
                                                                        (() => {
                                                                          try {
                                                                            const parsed = JSON.parse(course.course_image_name);
                                                                            return Array.isArray(parsed)
                                                                              ? `${Image_Base_Url}${parsed[0]?.image_path}`
                                                                              : `${Image_Base_Url}${parsed}`;
                                                                          } catch {
                                                                            return `${Image_Base_Url}${course.course_image_path || course.course_image_name}`;
                                                                          }
                                                                        })()
                                                                      }
                                                                      alt={course.course_title}
                                                                      className="img-cover w-100 h-100 rounded-start"
                                                                    />
                                        </div>
                                        <div class="col-md-6 mb-20">
                                            {/* <img src={`${Image_Base_Url}${course.course_image_path}`} alt=""/> */}
                                            <img
  src={
    (() => {
      try {
        const parsed = JSON.parse(course.course_image_name);
        if (Array.isArray(parsed)) {
          const imageToShow = parsed[1] ? parsed[1] : parsed[parsed.length - 1];
          return `${Image_Base_Url}${imageToShow.image_path}`;
        } else {
          return `${Image_Base_Url}${parsed}`;
        }
      } catch {
        return `${Image_Base_Url}${course.course_image_path || course.course_image_name}`;
      }
    })()
  }
  alt={course.course_title}
  className="img-cover w-100 h-100 rounded-start"
/>


                                        </div>

                                        <div class="col-md-6 mb-20">
                                            {/* <img src={`${Image_Base_Url}${course.course_image_path}`} alt=""/> */}
                                            <img
  src={
    (() => {
      try {
        const parsed = JSON.parse(course.course_image_name);
        if (Array.isArray(parsed)) {
          const imageToShow = parsed[2] ? parsed[2] : parsed[parsed.length - 1];
          return `${Image_Base_Url}${imageToShow.image_path}`;
        } else {
          return `${Image_Base_Url}${parsed}`;
        }
      } catch {
        return `${Image_Base_Url}${course.course_image_path || course.course_image_name}`;
      }
    })()
  }
  alt={course.course_title}
  className="img-cover w-100 h-100 rounded-start"
/>


                                        </div>
                                    </div>
                                    {/* <p class="mb-20">
                                        Power of choice is untrammelled and when nothing prevents our being able to do
                                        what we like best, every pleasure is to be welcomed and every pain avoided. But
                                        in certain circumstances and owing to the claims of duty or the obligations of
                                        business it will frequently occur that pleasures have to be repudiated and
                                        annoyances accepted. The wise man therefore always holds in these matters to
                                        this principle of selection.
                                    </p> */}
                                    <div class="my-4">
                                        <div class="mb-3">
                                            <h3 class="mb-3">Course Requirement</h3>
                                            <p>{course.course_requirements}</p>
                                        </div>
                                        <div class="mb-3">
                                            <h3 class="mb-3">Top Institute</h3>
                                            <p>{course.top_institute}</p>
                                        </div>
                                        <div class="mb-3">
                                            <h3 class="mb-3">Entrance Exam</h3>
                                            <p>{course.entrance_exam}</p>
                                        </div>
                                        {/* <ul class="course-single-list">
                                            <li><i class="fas fa-check"></i>Fusce justo risus placerat in risus eget
                                                tincidunt consequat elit.</li>
                                            <li><i class="fas fa-check"></i>Nunc fermentum sem sit amet dolor laoreet
                                                placerat.</li>
                                            <li><i class="fas fa-check"></i>Nullam rhoncus dictum diam quis ultrices.
                                            </li>
                                            <li><i class="fas fa-check"></i>Integer quis lorem est uspendisse eu augue
                                                porta ullamcorper dictum.</li>
                                            <li><i class="fas fa-check"></i>Quisque tristique neque arcu ut venenatis
                                                felis malesuada et.</li>
                                        </ul> */}
                                    </div>
                                    <div class="my-4">
                                        <h3 class="mb-3">Professional Experience</h3>
                                        <p>{course.professional_experience}</p>
                                    </div>
                                </div>
                                
                                <div id="reviews">
                                    <h4 class="pd-course-details-2-main-title">Ratings &amp; Reviews</h4>
                                    <div class="pd-course-details-2-review-rating">
                                        <div class="row gx-2">
                                            <div class="col-lg-4">
                                                <div class="pd-course-details-2-review-rating-info text-center">
                                                    <h5>{String(averageRatings)}</h5>
                                                    {/* <div class="course-rating">
                                                <i class="fas fa-star"></i>
                                                <i class="fas fa-star"></i>
                                                <i class="fas fa-star"></i>
                                                <i class="fas fa-star"></i>
                                                <i class="far fa-star"></i>

                                                    </div> */}
                                                    {ACCESS_TOKEN_NAME() ? (
                                                [...Array(5)].map((_, index) => (
                                                    //i === index ? ( // Use a ternary operator to conditionally render
                                                    <span
                                                        key={index + 1}
                                                        onClick={() => handleRating(index + 1, course.id)} // Function to handle user click
                                                        style={{
                                                            cursor: 'pointer',
                                                            color: index + 1 <= rating ? '#FFD700' : '#ccc', // Filled star if rating is equal or higher
                                                            fontSize: '24px',
                                                        }}
                                                    >
                                                        ★
                                                    </span>
                                                    // ) : null // Return null if the condition is not met
                                                ))
                                            ) : (

                                                (() => {
                                                    const numberValue = averageRatings === "NaN" ? NaN : parseFloat(averageRatings);
                                                    return (
                                                        <div>
                                                            {isNaN(numberValue) ? renderStars(0) : renderStars(numberValue)}
                                                        </div>
                                                    );
                                                })()

                                            )}
                                                    <p>Rated {String(averageRatings)} out of {courseRatingCount} Rating</p>
                                                </div>
                                            </div>
                                            <div class="col-lg-8">
                                                <div class="pd-course-details-2-review-details">
                                                    <div class="pd-course-details-2-review-content">
                                                   
                                                        <div class="pd-course-details-2-review-item d-flex align-items-center justify-content-between">
                                                            <div class="pd-course-details-2-review-text"><span>5 star</span></div>
                                                            <div class="pd-course-details-2-review-progress">
                                                                <div class="single-progress" style={{width:'82%'}}></div>
                                                            </div>
                                                            <div class="pd-course-details-2-review-percent">
                                                                <h5>82%</h5>
                                                            </div>
                                                        </div>
                                                        <div class="pd-course-details-2-review-item d-flex align-items-center justify-content-between">
                                                            <div class="pd-course-details-2-review-text"><span>4 star</span></div>
                                                            <div class="pd-course-details-2-review-progress">
                                                                <div class="single-progress" style={{width:'30%'}}></div>
                                                            </div>
                                                            <div class="pd-course-details-2-review-percent">
                                                                <h5>30%</h5>
                                                            </div>
                                                        </div>
                                                        <div class="pd-course-details-2-review-item d-flex align-items-center justify-content-between">
                                                            <div class="pd-course-details-2-review-text"><span>3 star</span></div>
                                                            <div class="pd-course-details-2-review-progress">
                                                                <div class="single-progress" style={{width:'15%'}}></div>
                                                            </div>
                                                            <div class="pd-course-details-2-review-percent">
                                                                <h5>15%</h5>
                                                            </div>
                                                        </div>
                                                        <div class="pd-course-details-2-review-item d-flex align-items-center justify-content-between">
                                                            <div class="pd-course-details-2-review-text"><span>2 star</span></div>
                                                            <div class="pd-course-details-2-review-progress">
                                                                <div class="single-progress" style={{width:'6%'}}></div>
                                                            </div>
                                                            <div class="pd-course-details-2-review-percent">
                                                                <h5>6%</h5>
                                                            </div>
                                                        </div>
                                                        <div class="pd-course-details-2-review-item d-flex align-items-center justify-content-between">
                                                            <div class="pd-course-details-2-review-text"><span>1 star</span></div>
                                                            <div class="pd-course-details-2-review-progress">
                                                                <div class="single-progress" style={{width:'6%'}}></div>
                                                            </div>
                                                            <div class="pd-course-details-2-review-percent">
                                                                <h5>10%</h5>
                                                            </div>
                                                        </div>
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4">
                            <div class="course-single-sidebar course_wraper-right">
                                <div class="widget">
                                   <div class="pd-course-details-2-widget-thumb position-relative">  <img
  src={
    (() => {
      try {
        const parsed = JSON.parse(course.course_image_name);
        if (Array.isArray(parsed)) {
          const imageToShow = parsed[4] ? parsed[4] : parsed[parsed.length - 1];
          return `${Image_Base_Url}${imageToShow.image_path}`;
        } else {
          return `${Image_Base_Url}${parsed}`;
        }
      } catch {
        return `${Image_Base_Url}${course.course_image_path || course.course_image_name}`;
      }
    })()
  }
  alt={course.course_title}
  className="img-cover w-100 h-100 rounded-start"
/>
<a href="#"><span><svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                   <path d="M0 1.83167C0 1.0405 0.875246 0.562658 1.54076 0.990487L12.6915 8.15882C13.3038 8.55246 13.3038 9.44754 12.6915 9.84118L1.54076 17.0095C0.875246 17.4373 0 16.9595 0 16.1683V1.83167Z" fill="#031F42"></path>
                                               </svg></span></a></div>
                                    
                                    <div class="price"><del>${course.course_price}</del><span>${course.course_discount_price}</span></div>
                                    
                                     {/* <a href="#" class="theme-btn">Add to Cart<i class="fas fa-arrow-right-long"></i></a> */}
                                     <button className="theme-btn" onClick={handleAddToCart}>Add to Cart<i class="fas fa-arrow-right-long"></i></button>
                                    <a href="#" class="theme-btn">Buy Course<i class="fas fa-arrow-right-long"></i></a>
                                </div>
                                <div class="widget">
                                    <h6>This course includes:</h6>
                                    <div class="course-feature-list">
                                        <a href="#"><i class="far fa-book-open"></i> Lectures <span>{course.lectures}</span></a>
                                        <a href="#"><i class="far fa-pencil"></i> Quizes <span>{course.quizes}</span></a>
                                        <a href="#"><i class="far fa-clock"></i> Duration <span>{course.course_duration}</span></a>
                                        <a href="#"><i class="far fa-globe"></i> Language <span>{course.select_language}</span></a>
                                        <a href="#"><i class="far fa-fill-drip"></i> Skill Level <span>{course.course_requirements}</span></a>
                                        <a href="#"><i class="far fa-location-dot"></i> Location <span>{course.location}</span></a>
                                        <a href="#"><i class="far fa-users"></i> Students <span>{course.students}</span></a>
                                        <a href="#"><i class="far fa-graduation-cap"></i> Certificate
                                            <span>{course.certificate}</span></a>
                                        <a href="#"><i class="far fa-check-circle"></i> Assessments <span>{course.assessments}</span></a>
                                    </div>
                                </div>
                                
                                <div class="pd-course-details-2-widget-search position-relative"><form action="#"><input type="text" placeholder="Enter Coupon Code"/><button type="submit">Apply</button></form></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      
    </main>
    <button class="btn btn-primary enquire_now" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Enquire Now</button>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
    <div class="offcanvas-header">
        <h4 id="offcanvasRightLabel">Enquire <span class="orange">Now</span></h4>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
        <div class="row contact-form py-0">
            <div class="col-md-12">
                <div class="form-group">
                    <input type="text" class="form-control" name="name" placeholder="Your Name" required=""/>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <input type="email" class="form-control" name="email" placeholder="Your Email" required=""/>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <input type="phone" class="form-control" name="phone" placeholder="Your Contact Number" required=""/>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <select class="form-select form-control" aria-label="city">
                            <option selected>City</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <select class="form-select form-control" aria-label="courses">
                            <option selected>Courses</option>
                            <option value="1">MBA</option>
                            <option value="2">BBA</option>
                            <option value="3">Btech</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <select class="form-select form-control" aria-label="courses">
                            <option selected>College for Admission</option>
                            <option value="1">MBA</option>
                            <option value="2">BBA</option>
                            <option value="3">Btech</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <textarea name="message" cols="30" rows="2" class="form-control" placeholder="Write Your Message"></textarea>
                    </div>
                </div>
                <button type="submit" class="theme-btn">Submit
                    <i class="far fa-paper-plane"></i></button>
            </div>
        </div>
    </div>
</div>

           
            <Footer />
        </div>
    );
}

export default CourseDetail;
